import { PageController } from '@client/components/_core/layout/PageController';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/products-v2/details/$productId')({
    params: {
        parse({ productId }) {
            return {
                productId: BigInt(productId),
            };
        },
    },
    beforeLoad({ context: { trpcUtils }, params }): ShareableRouteContext {
        void trpcUtils.product.getProduct.ensureData({ id: params.productId }).catch(() => undefined);

        return {
            breadcrumb: {
                // The product has no page of its own: its versions and its lodgement links do.
                inactive: true,
                async title() {
                    const product = await trpcUtils.product.getProduct.ensureData({ id: params.productId });

                    return product.name;
                },
            },
        };
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
